import React from 'react';
import { ListGroup, Button, Card, ListGroupItem as Base } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useParams } from 'react-router-dom';
import { sortBy } from 'lodash';
import { CardHeader, PseudoStates, useFetch } from '@cordata/buffet';

import ListGroupItem from './ListGroupItem';

type tAdmissionsCardProps = {
  limit: number,
  header?: boolean,
};

const AdmissionsCard = ({
  limit,
  header,
}: tAdmissionsCardProps) => {
  const params = useParams();
  const [status, data] = useFetch(`/patients/${params.patient_id}/admissions`);

  return (
    <Card>
      {header &&
        <CardHeader
          className="text-light"
          color="primary"
          action={
            <Button
              outline
              tag={Link}
              color="light"
              to={`/patients/${params.patient_id}/admissions/add`}
              size="sm"
            >
              <FontAwesomeIcon icon="plus" />
            </Button>
          }
        >
          Admissions
        </CardHeader>
      }

      {status === 'success' ? (
        <ListGroup flush>
          {sortBy(data, ['createdDate'])
            .reverse()
            .slice(0, limit)
            .map((d: any) => (
              <ListGroupItem
                key={d.id}
                data={d}
              />
            ))}

          {data.length > limit && (
            <Base
              action
              tag={Link}
              to={`/patients/${params.patient_id}/admissions`}
            >
              Show More ...
            </Base>
          )}

          {!data.length && (
            <Base>
              No admissions
            </Base>
          )}
        </ListGroup>
      ) : (
        <PseudoStates status={status} />
      )}
    </Card>
  );
};

AdmissionsCard.defaultProps = {
  header: true,
};

export default AdmissionsCard;
